<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  [dialogTitle]="(data.catalog.id ? 'Edit' : 'Create') + ' Catalog'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.catalog !== undefined && data.catalog !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Catalog"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.catalog.name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Catalog"
              matInput
              placeholder="Description (required)"
              [(ngModel)]="data.catalog.description">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Inject Type (required)</mat-label>
            <mat-select placeholder="Inject Type (required)" [(ngModel)]="data.catalog.injectTypeId" (ngModelChange)="loadDataFields()">
              @for (injectType of data.injectTypeList; track injectType.id) {
                <mat-option [value]="injectType.id" title="{{ injectType.name}}">
                  {{ injectType.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div class="partial-detail">
          <mat-checkbox
            [(ngModel)]="data.catalog.isPublic"
            class="bottom-margin"
            >
            Is a Public Catalog
          </mat-checkbox><br />
        </div>
      </div>
      @if (data.catalog.injectTypeId) {
        <div class="add-margin">
          <div class="full-width">
            <mat-label>Data Fields to Show on Inject List</mat-label>
            @for (dataField of getInjectTypeDataFields(); track dataField.id) {
              <div class="datafield-div">
                <mat-checkbox
                  [checked]="isInListDataFields(dataField.id)"
                  (change)="setDataFieldInList(dataField.id)"
                  class="bottom-margin"
                  >
                  {{ dataField.name }}
                </mat-checkbox><br />
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</crucible-dialog>
